module.exports = __webpack_public_path__ + "media/casana-modal_720p.ea6486e2.webm";